import { Icon, IconButton, Switch, Tooltip, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';
import { setEditMode } from '../../../redux/features/editModeSlice';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { setProgress } from '../../../redux/features/progressSlice';
import { flatObjectFromFhirPatient } from '../../../component/reusableLogic/fhirComplexObjectFlatning';
import {
  setCurrentTempPatientImageArray,
  setReduxCurrentPatientObject,
} from '../../../redux/features/currentSlice';

const EHRToolbar = props => {
  const { options, parentHandleOnClick, from } = props;
  const editMode = useSelector(state => {
    return state?.edit?.editMode;
  });

  const reduxDispatch = useDispatch();

  const navigate = useNavigate();

  const handleOnChange = event => {
    const { name, value, checked } = event?.target;
    if (name === 'editToggle') {
      reduxDispatch(setEditMode(checked));
    }
  };

  const toolBarContent = (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box>
          {options?.map((data, idx) => {
            return (
              <Tooltip title={data?.title}>
                <IconButton
                  onClick={event => {
                    let customEvent = {
                      target: {
                        name: '',
                      },
                    };

                    console.log(`ehrToolBar`, from);

                    if (from === 'encounter') {
                      customEvent.target.name = 'save';
                    }

                    if (from === 'patientEdit') {
                      customEvent.target.name = 'fullUpdate';
                      customEvent.patientObject = props?.patientObject;
                    }

                    if (from === 'allergy') {
                      customEvent.target.name = 'saveAllergies';
                    }

                    if (from === 'vitals') {
                      customEvent.target.name = 'save';
                    }
                    if (!_.isUndefined(data.click)) {
                      parentHandleOnClick(customEvent);
                    }

                    if (!_.isUndefined(data?.link)) {
                      if (data?.name === 'createPatient') {
                        reduxDispatch(setProgress(true));
                        flatObjectFromFhirPatient({}).then(() => {
                          reduxDispatch(setReduxCurrentPatientObject({}));
                          reduxDispatch(setCurrentTempPatientImageArray([]));
                          reduxDispatch(setEditMode(false));
                          navigate(data?.link, {
                            state: {
                              patientObject: undefined,
                              tabIndex: 0,
                            },
                          });
                        });
                      }
                    }
                  }}
                >
                  <Icon
                    sx={{
                      color: 'toolBarIcon',
                    }}
                  >
                    {data?.icon}
                  </Icon>
                </IconButton>
              </Tooltip>
            );
          })}
        </Box>
        <Box
          sx={{
            mr: 2,
          }}
        >
          <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <Typography
              sx={{
                color: 'toolBarIcon',
              }}
            >
              View
            </Typography>
            <Switch
              name={'editToggle'}
              checked={editMode}
              onChange={handleOnChange}
            />
            <Typography
              sx={{
                color: 'toolBarIcon',
              }}
            >
              Edit
            </Typography>
          </Stack>
        </Box>
      </Box>
    </>
  );

  return <>{toolBarContent}</>;
};

export default EHRToolbar;
